import { render } from "./Maps.vue?vue&type=template&id=22df9724"
import script from "./Maps.vue?vue&type=script&lang=js"
export * from "./Maps.vue?vue&type=script&lang=js"

import "./Maps.vue?vue&type=style&index=0&id=22df9724&lang=css"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__